import {
  SnippetElement,
  defineElement,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-main-product/common-main-product.ts
var CommonMainProduct = class extends SnippetElement {
  connectedCallback() {
    var _a, _b;
    const productHandle = this.product.getAttribute("data-product");
    (_a = this.cartOfferBtn) == null ? void 0 : _a.addEventListener("click", () => {
      var _a2;
      window.location.href = `/pages/anfrageformular/${productHandle != null ? productHandle : ""}&${(_a2 = this.quantity.value) != null ? _a2 : 1}?view=submission`;
    });
    (_b = this.quantity) == null ? void 0 : _b.addEventListener("change", () => {
      var _a2;
      console.log("Quantity changed");
      (_a2 = this.cartOfferBtn) == null ? void 0 : _a2.addEventListener("click", () => {
        var _a3;
        window.location.href = `/pages/anfrageformular/${productHandle != null ? productHandle : ""}&${(_a3 = this.quantity.value) != null ? _a3 : 1}?view=submission`;
      });
    });
  }
};
__decorateClass([
  query("[data-quantity]")
], CommonMainProduct.prototype, "quantity", 2);
__decorateClass([
  query("[data-product]")
], CommonMainProduct.prototype, "product", 2);
__decorateClass([
  query("[data-cart-offer]")
], CommonMainProduct.prototype, "cartOfferBtn", 2);
CommonMainProduct = __decorateClass([
  defineElement("common-main-product")
], CommonMainProduct);
export {
  CommonMainProduct
};
